
<template>
	<div class="innerBox">
		<div class="row">
		  <div class="col-md-6" :class="mobile ? 'order-1 mb-3' : 'order-2 text-right'">
			<button type="button" class="btn btn-sm btn-primary" @click="$router.push('/work-order-detail?wo=' + $route.params.work_order_code)">< Kembali</button>
		  </div>
		  <div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
			<h2 class="mb-4">Edit Gambar Work Order</h2>
		  </div>
		</div>
		
		<div class="p-5">
			<b-card no-body class="shadow tabbs" style="min-height : 400px">
				<b-tabs pills card vertical v-model="index" v-if="woDetail" style="min-height : 400px">
					<b-tab content-class="titleVariable" title="Kondisi Mobil Masuk" disabled></b-tab>
					<b-tab v-for="key in keys" :title="key.title" :key="key.variable">

						<div class="row">
							<div class="col-md-9">
								<h4>{{key.title}}</h4>
							</div>
							<div class="col-md-3 pr-3">
								<button class="w-100 btn btn-info" @click="downloadAll(woDetail.condition.figureOverall[key.variable] , woDetail.condition.figure[key.variable])">Download Gambar Bagian {{key.title}}</button>
							</div>
						</div>
						

						<hr>
						<div class="mt-2">
							<h5>Foto Keseluruhan Mobil</h5>
							<div class="row mt-1 mb-2">
								<template v-if="woDetail.condition.figureOverall[key.variable].image != 'test image' && woDetail.condition.figureOverall[key.variable].image != 'false'">
									<div class="col-4 col-md-3" v-for="(data, index) in woDetail.condition.figureOverall[key.variable].image" :key="index">
										<img :id="key.variable + 'overall'" :src="env.baseImage + '/' + data" class="imageRusak" @click="showImagePreview(env.baseImage + '/' + data)" />
									</div>
								</template>
								<div class="col-4 col-md-3 " >
									<div class=" border border-secondary rounded shadow pt-5 text-center imageRusak tambahGambar" @click="uploadImage(`this.woDetail.condition.figureOverall`, key.variable , 'Keseluruhan Mobil')">
										<span class="btn"><i class="fa fa-plus"></i> Tambah Gambar</span>
									</div>
								</div>
							</div>
							<p>Deskripsi Mobil : {{woDetail.condition.figureOverall[key.variable].desc}}</p>
						</div>
						
						<div v-for="keyPosition in Object.keys(woDetail.condition.figure[key.variable]).sort()" :key="keyPosition">
							<hr>
							<div class="mt-2">
								<h5>{{capitalize(keyPosition).split(/(?=[A-Z])/).join(" ")}}</h5>
								<div class="row mt-1 mb-2">
									<template v-if="woDetail.condition.figure[key.variable][keyPosition].image != 'false'">
									<div class="col-4 col-md-3" v-for="(data, index) in woDetail.condition.figure[key.variable][keyPosition].image" :key="index">
										<img :id="key.variable + keyPosition + index" :src="env.baseImage + '/' + data" class="imageRusak" @click="showImagePreview(env.baseImage + '/' + data)" />
									</div>
									</template>
									<div class="col-4 col-md-3 " >
										<div class=" border border-secondary rounded shadow pt-5 text-center imageRusak tambahGambar" @click="uploadImage(`this.woDetail.condition.figure['${key.variable}']`, keyPosition, capitalize(keyPosition).split(/(?=[A-Z])/).join(' '))">
											<span class="btn"><i class="fa fa-plus"></i> Tambah Gambar</span>
										</div>
									</div>
								</div>
								<p>Deskripsi Mobil : {{woDetail.condition.figure[key.variable][keyPosition].desc}}</p>
							</div>
						</div>


					</b-tab>
					<b-tab content-class="titleVariable" title="Foto Lainnya" disabled></b-tab>
					<b-tab content-class="titleVariable" title="Foto Epoxy">
						<!-- {{woProgress}} -->
						<div class="text-center mt-3" v-if="woProgress.length < 1">
							<h4>Tidak Ada Foto Epoxy</h4>
						</div>

						<div class="text-left mt-3" v-else>
							<!-- {{woProgress}} -->
							<div v-for="(epoxy , index) in woProgress" :key="index">
								<template v-if="epoxy.estimations.length > 0">
									<h5>{{capitalize(`Epoxy ${epoxy.estimations[0].sparepart.sparepart_variants.name} ${epoxy.estimations[0].extension}`)}}</h5>
									<h6>Tipe Pengerjaan : {{epoxy.estimations[0].type}}</h6>
									<!-- {{epoxy}} -->
									<div class="row" v-if="epoxy.status == 1">
										<div class="col-md-3 col-6" v-for="img in epoxy.img" :key="img">
											<img :src="env.baseImage + '/' + img" class="imageRusak" @click="showImagePreview(env.baseImage + '/' + img)" />
										</div>
									</div>
									<div v-else class="mt-3 mb-3">
										<h4 style="color:red">Epoxy Belum Selesai</h4>
									</div>
									<hr>
								</template>
							</div>
						</div>
					</b-tab>
					<b-tab content-class="titleVariable" title="Foto Tutup WO">
						<div class="text-center mt-3" v-if="!woDetail.post_condition">
							<h4>Work Order Belum ditutup</h4>
						</div>
						
						<div v-else>
							<!-- {{woDetail.post_condition.figureOverall}} -->

							<div v-for="key in Object.keys(woDetail.post_condition.figureOverall)">

								<h4>{{capitalize(key)}}</h4>
								
									<template v-if="woDetail.post_condition.figureOverall[key].image">
										<div class="row mt-4">
										<div class="col-4 col-md-3" v-for="(data, index) in woDetail.post_condition.figureOverall[key].image" :key="index">
											<img :src="env.baseImage + '/' + data" class="imageRusak" @click="showImagePreview(env.baseImage + '/' + data)"  />
										</div>
										</div>
									</template>
									<template v-else>
										<div class="mt-4">
											<h5>Gambar Tidak Tersedia Di System</h5>
										</div>
									</template>
								<hr>
							</div>
						</div>

					</b-tab>
				</b-tabs>
				<div v-else class="text-center pt-2 pb-2">
					<h3>Loading.....</h3>
				</div>
			</b-card>
		</div>

		<upload-image
			v-if="uploadModal"
			:title="modal.title"
			:endpoint="modal.endpoint"
			@onResponse="confirmUpload"
			@closeModal="uploadModal = false"
			:show_description="true"
		></upload-image>

		<preview-image
			v-if="modal.showImage"
			@closeModal="modal.showImage = false"
			:image="showImage"
		></preview-image>
	</div>
</template>

<script>
import uploadImage from '@/components/modal/uploadImage.vue'
import previewImage from '@/components/modal/previewImage'
import env from '@/env'

import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';

export default {
	components : {
		uploadImage,
		previewImage
	},
	data () {
		return {
			env,
			form_code : this.$route.params.work_order_code,
			woDetail : null,
			mobile : this.isMobile(),
			keys : null,
			index : 0,
			uploadModal :false,
			woProgress : null,
			modal : {
				title : '',
				endpoint : env.urlStart + '/api/v1/workorder/steps/upload',
				variableImage : null,
				position : null,
				showImage : false

			},
			showImage : null
		}
	},
	mounted () {
		this.getWoDetail()
		this.getWoProgress()
	},
	methods : {
		downloadAll(objOverall , obj) {
			// console.log(obj)
			obj.overAll = objOverall

			let result = []

			for(var i in obj){
				result.push([i , obj [i]]);
			}
			console.log(result)
    	
			let listUrl = []

			for(var i = 0 ; i < result.length ; i++) {
				let curRes = result[i][1].image
				for(var j = 0 ; j < curRes.length ; j ++) {
					if(curRes[j]) listUrl.push({
						url : curRes[j],
						name : result[i][0] + ' ' + (j + 1),
						ext : curRes[j].split('.')[1]
					})
				}
			}

			let zip = new JSZip()

			listUrl.forEach(val => {
				this.$http.get(`${env.baseImage}/${val.url}?not-from-cache-please`, {
				responseType: 'blob',
				timeout: 30000,
			}).then(function(response) {
					return response.blob();
				}).then(function(myBlob) {
					console.log(myBlob)
					zip.file(`${val.name}.${val.ext}` , myBlob)
				});
				
			})

			zip.generateAsync({type:"blob"}, function updateCallback(metadata) {
				// var msg = "progression : " + metadata.percent.toFixed(2) + " %";
				// if(metadata.currentFile) {
				// 	msg += ", current file = " + metadata.currentFile;
				// }
				// showMessage(msg);
				// updatePercent(metadata.percent|0);
			})
			.then(function callback(blob) {

				// see FileSaver.js
				saveAs(blob, "example.zip");

				// showMessage("done !");
			}, function (e) {
				// showError(e);
			});
			// console.log(listUrl)
		},
		// urlToPromise(url) {
		// 	return new Promise(function(resolve, reject) {
		// 		console.log(url)
		// 		// JSZipUtils.getBinaryContent(url, function (err, data) {
		// 		// 	if(err) {
		// 		// 		reject(err);
		// 		// 	} else {
		// 		// 		resolve(data);
		// 		// 	}
		// 		// });
		// 		fetch(url)
		// 	});
		// },
		showImagePreview(imgUrl){
			this.showImage = imgUrl
			this.modal.showImage = true;
		},
		getWoProgress() {
			this.$http.get(`/api/v1/workorder/steps/${this.form_code}`)
				.then((resp) => {
					this.woProgress = Object.assign([] , resp.data.data.filter(x => x.step.id == 6 && x.status != -1));


					for(var i = 0 ; i < this.woProgress.length ; i++) {
						

						// if(this.woProgress[i].status == 1) 
						// this.$set(this.woProgress[i], 'hide' , true)
						// else 
						// this.$set(this.woProgress[i], 'hide' , false)
					}

				})
				.catch((err) => {
					console.log(err)
				})
		},
		confirmUpload(image){
			this.uploadModal = false;
			let position = this.modal.position
			let variable = eval(this.modal.variableImage)
			// console.log(this.modal.variableImage)
			if(!variable[position]) {
				variable[position] = {
					image : [],
					desc : ''
				}
			}

			variable[position].desc += image.desc
			variable[position].image.push(image.image)

			let data = JSON.parse(JSON.stringify(this.woDetail))
			console.log(this.woDetail)
			// delete data.customer_id 
			data.customer.customer_id  = data.customer.id
			delete data.customer.id 
			data.customer_car.paint_name = ' '
			

			// console.log(JSON.stringify(data))
			let obj = {
				data : {
					data : {
						form_field_keys : [this.modal.variableImage.split('woDetail.')[1].replace(`['` , '.').replace(`']` , '')+ `.${position}`]
					}
				}
			}

			this.$http.delete('/api/v1/workorder/' + this.form_code + '/fields' , obj)
			.then((resp) => {
				this.$http.patch('/api/v1/workorder/' + this.form_code , {data : data})
				.then((resp) => {
					this.$store.dispatch('triggerAlert' , [true , 'Foto Berhasil Disimpan!'])
				})
				.catch((err) => {
					console.log(err)
				})
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Foto Gagal Tersimpan'])
				variable[position] = false
				console.log(err)
			})
			
			
			

		},
		uploadImage(variable , position, title) {
			this.uploadModal = true
			this.modal.title = `Tambah Gambar ${title}`
			this.modal.variableImage = variable
			this.modal.position = position
			// console.log(this.modal.variableImage)
		},
		getWoDetail () {
			this.$http.get(`/api/v1/workorder/${this.form_code}/detail`)
			.then((resp) => {
				this.woDetail = resp.data.data;
				this.keys = this.translate(Object.keys(this.woDetail.condition.figure))
			})
			.catch((err)=> {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Ada Masalah Dengan Sistem Kami. Mohon Dicoba Beberapa saat lagi.'])
			})
		},
		translate(data) {
			let newData = []

			for(var i = 0 ; i < data.length ; i++) {
				let obj = {}

				if(data[i] == 'front') {
					obj.title = 'Depan'
				}
				else if (data[i] == 'rear') {
					obj.title = 'Belakang'
				}
				else if (data[i] == 'atap') {
					obj.title = 'Atap'
				}
				else if (data[i] == 'left') {
					obj.title = 'Kiri'
				}
				else if (data[i] == 'right') {
					obj.title = 'Kanan'
				}

				obj.variable = data[i]
				newData.push(obj)
			}

			return newData;
		}
	}

}
</script>

<style scoped>
	.imageRusak {
		width : 100%;
		height: 150px;
	}
	.box {
		display: flex;
		align-items: flex-start;
		height: 150px;
		align-self: center;
	}
	.tambahGambar:hover {
		background-color: #BBB;
	}
	
</style>

<style>
	
	.tabs > .col-auto > .nav {
		background-color: #373737 !important;
		
	}

	.nav-link {
		color : #fff !important;
	}

	.nav-link.active {
		background-color : #bac7bc !important;
	}

	.nav-link.disabled {
		font-weight: bold !important;
		color : #999 !important ;
	}
</style>

